import DocsSiteAuth from '@/business-components/docs-site-auth/DocsSiteAuth';
import type { ErrorCodeMessageType } from '@/shared/constant/error/ErrorCodeMessageType';

export type UnauthorizedErrorProps = {
  value: ErrorCodeMessageType;
  className?: string;
};

export function UnauthorizedError(props: UnauthorizedErrorProps) {
  const { value } = props;

  return <DocsSiteAuth value={value} />;
}
